import awsLogo from '../../Assets/aws.jpg';
import shopifyLogo from '../../Assets/shopify.jpg';
import '../Styles/TrustedBy.css';

const TrustedBy = () => (
    <div className="trusted-by-section">
        <p>Trusted by</p>
        <div className="trusted-logos-container">
            <div className="trusted-logos">
                <img src={awsLogo} alt="AWS" />
                <img src={shopifyLogo} alt="Shopify" />
            </div>
        </div>
    </div>
);

export default TrustedBy;